import IRoleWhitespace from "interfaces/models/IRoleWhitespace";
import IClaim from "interfaces/responses/IClaimWhitespace";

const mapWhitespaceClaimToRole = (claim : IClaim) : IRoleWhitespace => {
  const role : IRoleWhitespace = {
    roleId: claim.id,
    roleName: claim.displayName
  };

  return role;
};

export { mapWhitespaceClaimToRole };
